<template>
  <div class="container_box">
    <!--头部筛选区域-->
    <div class="filter_box">
      <Form ref="pageParams" :model="pageParams" :label-width="labelWidth" @submit.native.prevent>
        <Row type="flex" :gutter="gutterItem">
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1002327')" prop="warehouseName">
              <Input v-model.trim="pageParams.warehouseName" :placeholder="$t('key1002597')" clearable></Input>
            </FormItem>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1002433')" prop="ymsDeliveryPlaceId">
              <Select v-model="pageParams.ymsDeliveryPlaceId" transfer>
                <Option v-for="item in placeOfShipmentList" :key="item.ymsDeliveryPlaceId" :value="item.ymsDeliveryPlaceId">{{ item.deliveryPlaceName }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1002598')" prop="countryCode">
              <Select v-model="pageParams.countryCode" filterable>
                <Option v-for="item in countrysList" :value="item.twoCode" :key="item.twoCode">{{ item.name }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1002164')">
              <local-tabButton :tabButtonList="statusList" @selectStatus="statusBtn"></local-tabButton>
            </FormItem>
          </Col>
          <Col style="min-width: 200px;" push="1">
            <Button @click="reset" icon="md-refresh" class="mr10">{{ $t('key1000109') }}</Button>
            <Button type="primary" @click="search" icon="md-search">{{ $t('key1000361') }}</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <!--功能按钮操作区域-->
    <div class="operation_box justify-content-between">
      <!--新增仓库-->
      <Button class="mr15" type="primary" v-if="getPermission('wmsWarehouse_create')"
        @click="$refs['supplierWarehouse'].initSupplierWarehouseData('add')">{{ $t('key1002414') }}</Button>
      <Button type="primary" v-if="getPermission('supplyPriorityConfiguration_update')"
        @click="$refs['supplyPriorityConfiguration'].initSupplyPriorityConfigurationData()">{{ $t('key1007104') }}</Button>
    </div>
    <!--列表区域-->
    <div class="table_box">
      <Table
        ref="selection"
        highlight-row
        :loading="tableLoading"
        border
        max-height="520"
        :columns="tableColumns"
        :data="tableData">
      </Table>
      <Page
        :transfer="true"
        v-if="!tableLoading"
        :total="total"
        @on-change="changePage"
        show-total
        :page-size="pageParams.pageSize"
        show-elevator
        :current="pageParams.pageNum"
        show-sizer
        @on-page-size-change="changePageSize"
        placement="top"
        :page-size-opts="pageArray">
      </Page>
    </div>
    <!--新增、编辑仓库弹窗-->
    <supplierWarehouseModal
      ref="supplierWarehouse"
      @updateData="pageParamsStatus=true"
    :countrysOriginalData="countrysOriginalData">
    </supplierWarehouseModal>
    <!--供货优先级配置弹窗-->
    <supplyPriorityConfigurationModal ref="supplyPriorityConfiguration"></supplyPriorityConfigurationModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import supplierWarehouseModal from "@/views/supplier/components/warehouseLogistics/supplierWarehouseModal.vue";
import supplyPriorityConfigurationModal from "@/views/supplier/components/warehouseLogistics/supplyPriorityConfigurationModal.vue";
import {getAllCountrysData, getBatchDeliveryAreasName, getPlaceOfShipmentCountryData, isValueEmpty} from "@/utils/common";

export default {
  name: 'supplierWarehouseManage',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      pageParamsStatus: false,
      pageParams: {
        warehouseName: '',
        ymsDeliveryPlaceId: null,
        countryCode: null,
        warehouseStatus: null,
        orderBy: 'createdTime',
        upDown: 'down',
        pageNum: 1,
        pageSize: 15
      },
      total: 0,
      tableColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000241'),
          key: 'warehouseName',
          minWidth: 120,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007130'),
          key: 'warehouseCode',
          minWidth: 120,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002585'),
          key: 'deliveryPlaceName',
          minWidth: 140,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002586'),
          key: 'countryCode',
          minWidth: 140,
          align: 'center',
          render(h, params) {
            let twoCode = params.row.countryCode || null;
            let text = '';
            if (v.countrysList.length > 0) {
              v.countrysList.map((item) => {
                if (item.twoCode === twoCode) {
                  text = item.cnName;
                }
              });
              return h('span', text);
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002157'),
          key: 'warehouseStatus',
          minWidth: 100,
          align: 'center',
          render(h, params) {
            let typeList = [
              {type: 'success', text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000462')},
              {type: 'error', text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463')}
            ];
            let warehouseStatus = params.row.warehouseStatus;
            if (!isValueEmpty(warehouseStatus)) {
              return h('Badge', {
                props: {
                  status: typeList[warehouseStatus].type,
                  text: typeList[warehouseStatus].text || '-'
                },
                class: warehouseStatus === 1 ? 'stopStatus' : ''
              });
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002159'),
          key: 'createdTime',
          minWidth: 180,
          align: 'center',
          render: (h, params) => {
            return h('span', v.$uDate.dealTime(params.row.createdTime, 'fulltime'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'options',
          align: 'center',
          width: 210,
          render: (h, params) => {
            let warehouseId = params.row.warehouseId;
            let warehouseStatus = params.row.warehouseStatus;
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002184'),
                    show: v.getPermission('wmsWarehouse_update'),
                    clickFn: () => {
                      v.$refs['supplierWarehouse'].initSupplierWarehouseData('edit', params.row);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000462'),
                    show: warehouseStatus === 1 && v.getPermission('wmsWarehouse_enable'),
                    color: '#20c711',
                    clickFn: () => {
                      v.operationHandel('enable', warehouseId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463'),
                    show: warehouseStatus === 0 && v.getPermission('wmsWarehouse_disable'),
                    color: '#ed4014',
                    clickFn: () => {
                      v.operationHandel('disable', warehouseId);
                    }
                  },
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      tableData: [],
      placeOfShipmentList: [],
      countrysList: [],
      countrysOriginalData: [],
      statusList: [
        {selected: true, value: null, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')},
        {selected: false, value: 0, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000462')},
        {selected: false, value: 1, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463')}
      ]
    };
  },
  created() {
    getAllCountrysData('cn', true).then((data) => {
      this.countrysOriginalData = data;
      this.search();
    });
  },
  methods: {
    // 查询按钮
    search() {
      this.pageParams.pageNum = 1;
      this.getList();
    },
    // 重置按钮
    reset() {
      this.$nextTick(() => {
        this.$refs['pageParams'].resetFields();
        this.statusBtn(0, null);
        this.search();
      });
    },
    // 获取发货地与国家信息数据
    getPlaceOfShipmentCountryList() {
      getPlaceOfShipmentCountryData().then((obj) => {
        let countryCodes = obj.countryCodes || [];
        this.placeOfShipmentList = obj.ymsDeliveryPlaces || [];
        this.countrysList = this.countrysOriginalData.filter((item) => {
          return countryCodes.includes(item.twoCode);
        });
      });
    },
    // 处理接口参数
    handleParameter() {
      let v = this;
      let params = Object.assign({}, v.pageParams);
      return params;
    },
    // 获取列表数据
    getList() {
      let v = this;
      v.optionBtnWidth = [];
      v.tableData = [];
      v.total = 0;
      v.getPlaceOfShipmentCountryList();
      if (v.getPermission('wmsWarehouse_query')) {
        v.tableLoading = true;
        v.axios.post(api.post_wmsWarehouse_query, v.handleParameter()).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            if (data) {
              v.total = data.total;
              let list = data.list || [];
              const ymsDeliveryPlaceIdList = list.map(item => item.ymsDeliveryPlaceId).filter(id => id);
              if (ymsDeliveryPlaceIdList.length > 0) {
                getBatchDeliveryAreasName(ymsDeliveryPlaceIdList).then((newData) => {
                  const nameMap = new Map(newData.map(ele => [ele.ymsDeliveryPlaceId, ele.deliveryPlaceName]));
                  list.forEach(item => {
                    if (nameMap.has(item.ymsDeliveryPlaceId)) {
                      item.deliveryPlaceName = nameMap.get(item.ymsDeliveryPlaceId);
                    }
                    item.warehouseStatus = Number(item.warehouseStatus);
                  });
                  v.tableData = list;
                  v.updateTableDom('selection');
                });
              } else {
                v.tableData = list;
                v.tableLoading = false;
              }
            } else {
              v.tableLoading = false;
            }
          } else {
            v.tableLoading = false;
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 启用、停用仓库按钮
    operationHandel(type, warehouseId) {
      const v = this;
      const configMap = {
        enable: {
          url: api.put_wmsWarehouse_enable + warehouseId,
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003567'),
          content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007131'),
          successText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002485')
        },
        disable: {
          url: api.put_wmsWarehouse_disable + warehouseId,
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002470'),
          content: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007128')}</br>
                    <p style="color: red;">${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007129')}</p>`,
          successText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002486')
        }
      };
      const config = configMap[type];
      if (config) {
        let {title, content, url, successText} = config;
        v.$Modal.confirm({
          title: title,
          dangerouslyUseHTMLString: true,
          content: content,
          okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000543'),
          cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
          onOk: () => {
            v.axios.put(url, null, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
              if (response.data.code === 0) {
                v.$Message.success(successText);
                v.pageParamsStatus = true;
              }
            });
          }
        });
      }
    },
    // 选取状态
    statusBtn(index, value) {
      let v = this;
      v.pageParams.warehouseStatus = value;
      v.statusList.forEach((n, i) => {
        n.selected = i === index;
      });
    },
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    },
  },
  components: {
    supplierWarehouseModal,
    supplyPriorityConfigurationModal
  }
};
</script>

<style lang="less">

</style>
